<template>
  <div class="profileView">
    <v-container class="responsive-height custom-container">

      <!-- top section -->
      <v-row dense>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'" class="my-profile">
            <v-card-actions class="pl-5 align-start py-1">
              <v-icon class="mt-4" color="#708AA7">mdi mdi-account-check-outline</v-icon>
              <v-card-text class="px-0 py-0">
                <v-card-title
                  :style="`color:${client?.profileStatus === 'Not Approved' ? '#FF567F' : client?.profileStatus === 'Pending' ? '#D19909' : '#039de9'}`">
                  Profile
                  <span class="ml-1">{{ client?.profileStatus }}</span>
                </v-card-title>
                <v-card-subtitle>Verification Status</v-card-subtitle>
              </v-card-text>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'"
            class="d-flex align-center justify-space-between my-profile">
            <v-card-actions class="pl-5 align-start py-1">
              <v-icon class="mt-4" color="#708AA7">mdi mdi-seal-variant</v-icon>
              <v-card-text class="px-0 py-0 align-start">
                <v-card-title>
                  <span
                    :style="`color:${client?.ibStatus === 'Approved' ? '#039de9' : client?.ibStatus === 'Requested' ? '#D19909' : '#FF567F'}`">{{
                      client?.ibStatus }}</span>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="ml-2" small color="greenMain" v-bind="attrs" v-on="on">
                        mdi mdi-information-outline
                      </v-icon>
                    </template>
                    <span>Current IB Status</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-subtitle>IB Status</v-card-subtitle>
              </v-card-text>
            </v-card-actions>
            <v-btn v-if="client?.ib_status != 1 || client?.ib_status != 2"
              :disabled="client?.ib_status === 1 || client?.ib_status === 2" class="mx-2 mb-3" tile link small
              elevation="0" color="greenMain" @click.prevent="BECOMEANIB">
              Become an IB
            </v-btn>
          </v-card>
        </v-col>
      </v-row>

      <!-- Personal info section -->
      <v-row dense>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card class="user-profile-card" flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'">
            <v-card-title>
              <v-icon class="pr-5" color="#708AA7">mdi mdi-account-outline</v-icon>
              {{ client?.fname }} {{ client?.lname }}
            </v-card-title>
            <v-card-actions>
              <v-card-text class="py-0 pr-0 flex-basic">
                <v-badge avatar :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'">
                  <template v-slot:badge>
                    <v-icon @click="openFileInput" color="greenMain">mdi mdi-square-edit-outline</v-icon>
                    <input type="file" @change="handleImageChange" accept="image/*" style="display: none" />
                  </template>
                  <v-avatar size="105" @click="openFileInput" style="border: 2px solid #f1f7fb; border-radius: 100%">
                    <v-img :src="profileImageUrl" :alt="client?.profile_pic_url"></v-img>
                  </v-avatar>
                </v-badge>
              </v-card-text>
              <v-card-text class="pa-0">
                <v-card-subtitle class="pa-0 mb-3">
                  <span class="d-block">User ID </span>

                  <span>{{ client?.id }}</span>
                </v-card-subtitle>
                <v-card-subtitle class="pa-0">
                  <span class="d-block">Email</span>
                  <span>{{ client?.email }}</span>
                </v-card-subtitle>
              </v-card-text>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card class="user-profile-card" flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'">
            <v-card-title class="d-flex justify-space-between align-center">
              <span>Personal Information</span>
              <v-dialog v-model="editDialogOpen" @open="initializeFormData" transition="scale-transition"
                origin="center center" max-width="554" content-class="deposit-withdraw-popup">
                <template v-slot:activator="{ on, attrs }">
                  <span class="edit" v-bind="attrs" v-on="on" @click="initializeFormData">Edit</span>
                </template>
                <template v-slot:default="dialog">
                  <v-card class="rounded-0 deposit-form" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                    <v-card-title class="mb-5">Edit Personal Information</v-card-title>

                    <v-row>
                      <!-- Country Selection -->
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <fieldset>
                          <legend>Country</legend>
                          <v-select v-model="clientInfo.country" @input="onCountryChange" :items="countries"
                            item-text="name" item-value="id" :value="client?.country_id" solo
                            append-icon="mdi-chevron-down" label="Select One" class="custom-select" hide-details
                            single-line>
                          </v-select>
                        </fieldset>
                      </v-col>

                      <!-- State Selection -->
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <fieldset>
                          <legend>State Province</legend>
                          <v-select v-model="clientInfo.state" @input="onStateChange" :items="states" item-text="name"
                            item-value="id" :value="client?.state_id" solo append-icon="mdi-chevron-down"
                            label="Select One" class="custom-select" hide-details>
                          </v-select>
                        </fieldset>
                      </v-col>

                      <!-- City Province and Postal Code -->
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <fieldset>
                          <legend>City</legend>
                          <v-select v-model="clientInfo.city" @input="onCityChange" :items="cities" item-text="name"
                            item-value="id" :value="client?.city_id" solo append-icon="mdi-chevron-down"
                            label="Select One" class="custom-select" hide-details>
                          </v-select>
                        </fieldset>
                      </v-col>

                      <v-col cols="12" sm="6" md="6" lg="6">
                        <fieldset>
                          <legend>Postal Code</legend>
                          <v-text-field v-model="clientInfo.postal_code" :placeholder="client?.postal_code" single-line
                            solo hide-details class="custom-select">
                          </v-text-field>
                        </fieldset>
                      </v-col>

                      <!-- Street Address -->
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <fieldset class="textarea-field">
                          <legend>Street Address</legend>
                          <v-textarea v-model="clientInfo.address" :placeholder="client?.address" single-line solo
                            hide-details class="custom-textarea">
                          </v-textarea>
                        </fieldset>
                      </v-col>

                      <!-- Birthday Date -->
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition"
                          offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="date" label="Birthday date" prepend-icon="mdi-calendar" readonly
                              v-bind="attrs" v-on="on" single-line solo hide-details
                              class="custom-select-datepicker"></v-text-field>
                          </template>
                          <v-date-picker v-model="date" :active-picker.sync="activePicker" :max="new Date(
                            Date.now() -
                            new Date().getTimezoneOffset() * 60000
                          )
                            .toISOString()
                            .substring(0, 10)
                            " min="1950-01-01" @change="SaveMenu"></v-date-picker>
                        </v-menu>
                      </v-col>

                      <!-- Phone Number -->
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <fieldset>
                          <legend>Phone Number</legend>
                          <v-text-field v-model="clientInfo.mobile" :placeholder="client?.mobile" single-line solo
                            hide-details class="custom-select">
                          </v-text-field>
                        </fieldset>
                      </v-col>

                      <!-- Update button -->
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <v-btn :loading="isLoading" :disabled="isLoading" tile elevation="0"
                          class="ma-0 text-capitalize btn-account px-10" color="greenMain"
                          @click.prevent="updateProfile">
                          Update
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </template>
              </v-dialog>
            </v-card-title>
            <v-card-actions>
              <v-card-text class="py-0 pr-0">
                <v-card-text class="pa-0">
                  <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                    <span>Country: </span>
                    <span>{{ client?.countries?.name || "N/A" }}</span>
                  </v-card-subtitle>
                  <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                    <span>Phone No: </span>
                    <span>{{ client?.mobile || "N/A" }}</span>
                  </v-card-subtitle>
                  <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                    <span>State: </span>
                    <span>{{ client?.states?.name || "N/A" }}</span>
                  </v-card-subtitle>
                  <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                    <span>Date of Birth: </span>
                    <span>{{ formatDate(client?.dob) || "N/A" }}</span>
                  </v-card-subtitle>
                </v-card-text>
              </v-card-text>
              <v-card-text class="py-0 pr-0">
                <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                  <span>City: </span>
                  <span>{{ client?.cities?.name || "N/A" }}</span>
                </v-card-subtitle>
                <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                  <span>Zipcode: </span>
                  <span>{{ client?.postal_code || "N/A" }}</span>
                </v-card-subtitle>
                <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                  <span>Street Address: </span>
                  <span>{{ client?.address || "N/A" }}</span>
                </v-card-subtitle>
              </v-card-text>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

       <!-- ✅ 2FA Management section (TOGGLE) -->
      <v-row dense v-if="show2faBlock">
        <v-col cols="12">
          <v-card flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'"
            class="d-flex align-center justify-space-between my-profile">
            <v-card-actions class="pl-5 align-start py-1">
              <v-icon class="mt-4" color="#708AA7">mdi-shield-key-outline</v-icon>
              <v-card-text class="px-0 py-0">
                <v-card-title class="terms">Two-Factor Authentication (2FA)</v-card-title>
                <v-card-subtitle>
                  Secure your account with Authenticator app
                </v-card-subtitle>
              </v-card-text>
            </v-card-actions>

            <div class="d-flex align-center">
              <!-- ✅ same button toggles -->
              <v-btn class="mx-2 mb-3" tile small elevation="0" :color="is2faEnabled ? '#FF567F' : 'greenMain'"
                @click="open2faToggleDialog">
                {{ is2faEnabled ? "Disable 2FA" : "Enable 2FA" }}
              </v-btn>
            </div>
          </v-card>

          <v-dialog v-model="twoFaDialog" max-width="680" content-class="twofa-dialog"
            transition="dialog-bottom-transition">
            <v-card class="twofa-card" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
              <!-- Header -->
              <div class="twofa-header d-flex align-center justify-space-between px-6 py-4">
                <div class="d-flex align-center">
                  <v-icon class="mr-3" :color="$vuetify.theme.dark ? '#7EA6D6' : '#3B5B7A'">
                    mdi-shield-key-outline
                  </v-icon>

                  <div>
                    <div class="twofa-title">{{ twoFaDialogTitle }}</div>
                    <div class="twofa-subtitle">
                      {{ twoFaMode === 'disable'
                        ? 'Confirm with your authenticator code to turn it off.'
                        : 'Use an authenticator app to keep your account secure.' }}
                    </div>
                  </div>
                </div>

                <v-btn icon @click="close2faDialog" class="twofa-close"
                  :color="$vuetify.theme.dark ? '#E6F0FF' : '#172233'">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>

              <v-divider class="twofa-divider" />

              <!-- Body -->
              <v-card-text class="px-6 pt-5 pb-0">
                <div class="twofa-steps mb-5">
                  <div class="twofa-step" v-if="twoFaMode === 'setup'">
                    <div class="step-title">Setup steps</div>
                    <ol class="step-list">
                      <li>Install Google Authenticator (or similar)</li>
                      <li>Scan the QR code</li>
                      <li>Enter the 6-digit code to enable 2FA</li>
                    </ol>
                  </div>

                  <div class="twofa-step" v-else-if="twoFaMode === 'activate'">
                    <div class="step-title">Enable 2FA</div>
                    <ol class="step-list">
                      <li>Your authenticator is already registered</li>
                      <li>Open your authenticator app</li>
                      <li>Enter the 6-digit code to enable</li>
                    </ol>
                  </div>

                  <div class="twofa-step" v-else>
                    <div class="step-title">Disable 2FA</div>
                    <ol class="step-list">
                      <li>Open your authenticator app</li>
                      <li>Enter the 6-digit code to disable</li>
                    </ol>
                  </div>
                </div>

                <v-row align="stretch" class="pb-2">
                  <!-- QR panel -->
                  <v-col cols="12" md="5" v-if="twoFaMode === 'setup'">
                    <div class="twofa-qr-wrap">
                      <div class="qr-title mb-3">Scan QR</div>
                      <v-skeleton-loader v-if="twoFaLoading" type="image" />
                      <v-img v-else :src="twoFaSetup?.qr" max-width="240" contain class="mx-auto twofa-qr" />
                      <div class="qr-hint mt-3">
                        Use your authenticator app to scan this code.
                      </div>
                    </div>
                  </v-col>

                  <!-- OTP panel -->
                  <v-col cols="12" :md="twoFaMode === 'setup' ? 7 : 12">
                    <div class="twofa-otp-wrap">
                      <div class="otp-title mb-2">Authenticator code</div>

                      <v-text-field v-model="twoFaOtp" placeholder="123456" solo hide-details maxlength="6"
                        class="twofa-otp-input" :background-color="$vuetify.theme.dark ? '#0F1B2A' : '#FFFFFF'"
                        :color="$vuetify.theme.dark ? '#E6F0FF' : '#172233'"
                        @input="twoFaOtp = (twoFaOtp || '').replace(/[^0-9]/g, '').slice(0, 6)"
                        prepend-inner-icon="mdi-lock-outline" />

                      <v-btn class="mt-4 twofa-action" tile elevation="0"
                        :color="twoFaMode === 'disable' ? '#FF567F' : 'greenMain'" :loading="twoFaConfirmLoading"
                        :disabled="twoFaConfirmLoading || (twoFaOtp || '').length !== 6" @click="confirmTwoFaToggle">
                        {{ twoFaConfirmBtnText }}
                      </v-btn>

                      <div class="otp-note mt-3" v-if="twoFaMode !== 'disable'">
                        Tip: If the code fails, wait for the next code and try again.
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions class="px-6 pb-5 pt-0">
                <v-spacer />
                <v-btn text class="twofa-cancel" @click="close2faDialog">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-col>
      </v-row>


      <!-- terms and conditions section -->
      <v-row dense>
        <v-col lg="12" md="12" sm="12" cols="12">
          <v-card flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'"
            class="d-flex align-center justify-space-between my-profile">
            <v-card-actions class="pl-5 align-start py-1">
              <v-icon class="mt-4" color="#708AA7">mdi-file-document-outline</v-icon>
              <v-card-text class="px-0 py-0">
                <v-card-title class="terms">
                  Your Terms & Conditions
                </v-card-title>
              </v-card-text>
            </v-card-actions>
            <v-btn class="mx-2 mb-3" tile link to="/terms-and-condition" small elevation="0" color="greenMain">
              See T&C / Approve
            </v-btn>
          </v-card>
        </v-col>
      </v-row>

      <!-- Identity and residence verifiation section -->
      <v-row dense>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card v-if="client?.identity !== 1" class="verification-card" flat tile
            :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'">
            <v-card-actions class="justify-space-between px-0">
              <v-card-title class="pl-1">
                <v-icon class="pr-5" color="#708AA7">mdi mdi-account-outline</v-icon>Identity Verification
              </v-card-title>
              <v-dialog transition="scale-transition" origin="center center" max-width="554"
                content-class="deposit-withdraw-popup">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile text elevation="0" class="text-capitalize link text-decoration-underline" color="#5f7692"
                    v-bind="attrs" v-on="on">Detail</v-btn>
                </template>
                <template v-slot:default="dialog">
                  <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                    <v-card-title class="ps-0 pt-0 pb-5 rounded-0">Identity Verification</v-card-title>
                    <v-card-text>
                      <p>
                        To complete the identity verification process, kindly
                        provide colour, high-resolution scans or images of a
                        document with your entire name, picture, signature,
                        birthdate, and expiration date. The application must be
                        submitted on or before the date of the document's
                        validity, and all information must be easily readable.
                      </p>
                    </v-card-text>
                    <v-card-title class="ps-0 pt-0 pb-5 rounded-0">Conditions for Uploading Documents</v-card-title>
                    <v-card-text>
                      <p>
                        All clients must finish a verification process as part
                        of Forex CRM's compliance with AML (Anti-Money
                        Laundering) regulations. Verified clients are free to
                        use any available way to deposit money into their
                        trading accounts or withdraw monies, without any
                        limitations.
                      </p>
                    </v-card-text>
                    <v-card-text>
                      <p>
                        In order to authenticate your identity and address,
                        kindly provide a colour photo or a scanned copy of one
                        of these documents:
                      </p>
                    </v-card-text>
                    <ol class="mb-5">
                      <li>Domestic Passport (IC, ID)</li>
                      <li>Overseas Passport</li>
                      <li>A Driver's License</li>
                      <li>Receipt for a Utility Bill</li>
                      <li>Statement from the Bank</li>
                    </ol>
                    <v-card-text>
                      <p>
                        All required paperwork must be color, high-resolution
                        scans or images with a minimum of six months remaining
                        on the validity date. These images or scans must clearly
                        show your full name, photo, signature, date of birth,
                        and expiration date. Make sure the picture displays the
                        document's four edges.
                      </p>
                    </v-card-text>

                  </v-card>
                </template>
              </v-dialog>
            </v-card-actions>

            <!-- IDENTITY VERIFICATION -->
            <v-card-subtitle class="text-center">
              <span class="d-block">Upload: Local or international passport (ID, IC), National Indentity Card</span>
              or driver's licens in either PNG, JPG, or JPEG format.
            </v-card-subtitle>
            <div class="custom-upload-area">
              <input type="file" ref="residenceFileInput" class="file-input" accept="image/jpeg,image/jpg,image/png"
                @change="handleResidenceFile" />

              <div class="content">
                <v-row style="position: absolute; bottom: 40px; right: 50%" v-if="residentUploading">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>

                <v-icon large class="mb-3" color="#708AA7">mdi mdi-tray-arrow-up</v-icon>
                <p class="mb-0">Drop File Here or <strong>Browse</strong></p>
                <span class="text-sm">File size max 4MB</span>
              </div>
            </div>

          </v-card>

          <v-card v-else class="verification-card pb-0" style="height: 100%;" flat tile
            :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'">
            <v-card-actions class="justify-space-between px-0">
              <v-card-title class="pl-1">
                <v-icon class="pr-5" color="#708AA7">mdi mdi-account-outline</v-icon>Identity Verification
              </v-card-title>
              <v-dialog transition="scale-transition" origin="center center" max-width="654"
                content-class="deposit-withdraw-popup">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile text elevation="0" class="text-capitalize link text-decoration-underline" color="#5f7692"
                    v-bind="attrs" v-on="on">Detail</v-btn>
                </template>
                <template v-slot:default="dialog">
                  <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                    <v-card-title class="ps-0 pt-0 pb-5 rounded-0">Identity Verification</v-card-title>
                    <v-card-text>
                      <p>
                        To complete the identity verification process, kindly
                        provide colour, high-resolution scans or images of a
                        document with your entire name, picture, signature,
                        birthdate, and expiration date. The application must be
                        submitted on or before the date of the document's
                        validity, and all information must be easily readable.
                      </p>
                    </v-card-text>
                    <v-card-title class="ps-0 pt-0 pb-5 rounded-0">Conditions for Uploading Documents</v-card-title>
                    <v-card-text>
                      <p>
                        All clients must finish a verification process as part
                        of Forex CRM's compliance with AML (Anti-Money
                        Laundering) regulations. Verified clients are free to
                        use any available way to deposit money into their
                        trading accounts or withdraw monies, without any
                        limitations.
                      </p>
                    </v-card-text>
                    <v-card-text>
                      <p>
                        In order to authenticate your identity and address,
                        kindly provide a colour photo or a scanned copy of one
                        of these documents:
                      </p>
                    </v-card-text>
                    <ol class="mb-5">
                      <li>Domestic Passport (IC, ID)</li>
                      <li>Overseas Passport</li>
                      <li>A Driver's License</li>
                      <li>Receipt for a Utility Bill</li>
                      <li>Statement from the Bank</li>
                    </ol>
                    <v-card-text>
                      <p>
                        All required paperwork must be color, high-resolution
                        scans or images with a minimum of six months remaining
                        on the validity date. These images or scans must clearly
                        show your full name, photo, signature, date of birth,
                        and expiration date. Make sure the picture displays the
                        document's four edges.
                      </p>
                    </v-card-text>

                  </v-card>
                </template>
              </v-dialog>
            </v-card-actions>
            <!-- modify this section -->
            <v-card-text class="content">
              <v-icon color="greenMain">mdi mdi-account-check-outline</v-icon>
              <h3>Identity Verified</h3>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card v-if="client?.resident !== 1" class="verification-card" flat tile
            :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'">
            <v-card-actions class="justify-space-between px-0">
              <v-card-title class="pl-1">
                <v-icon class="pr-5" color="#708AA7">mdi mdi-home-lightning-bolt-outline</v-icon>Residence Verification
              </v-card-title>
              <v-dialog transition="scale-transition" origin="center center" max-width="654"
                content-class="deposit-withdraw-popup">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile text elevation="0" class="text-capitalize link text-decoration-underline" color="#5f7692"
                    v-bind="attrs" v-on="on">Detail</v-btn>
                </template>
                <template v-slot:default="dialog">
                  <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">

                    <v-card-title class="ps-0 pt-0 pb-5 rounded-0">Residence Verification</v-card-title>
                    <v-card-text>
                      <p>
                        Please submit color, high-resolution scans or pictures
                        of a document with your complete name and address on it
                        as proof of residency; the details must match those in
                        your profile. The material must be released no later
                        than three months before the deadline for submission.
                      </p>
                    </v-card-text>
                    <v-card-title class="ps-0 pt-0 pb-5 rounded-0">Upload Requirements for Documents</v-card-title>
                    <v-card-text>
                      <p>
                        To ensure compliance with AML (Anti-Money Laundering)
                        regulations, Forex CRM mandates that all of its clients
                        undergo a verification process. Clients that have
                        undergone verification are free to use any available
                        means to withdraw money and deposit it into their
                        trading accounts.
                      </p>
                    </v-card-text>
                    <v-card-text>
                      <p>
                        Please upload a colour photo or a scanned copy of one of
                        the following papers to help us verify your identity and
                        address:
                      </p>
                    </v-card-text>
                    <ol class="mb-5">
                      <li>Passport local (ID, IC)</li>
                      <li>Foreign Passport</li>
                      <li>License to Drive</li>
                      <li>Receipt of Utility Bill</li>
                      <li>A Bank Statement</li>
                    </ol>
                    <v-card-text>
                      <p>
                        Each document must be a high-resolution colour scan or
                        photo with a validity period of at least six months that
                        clearly shows your full name, photo, signature, date of
                        birth, and expiration date. Make sure the image captures
                        the document's four edges.
                      </p>
                    </v-card-text>
                  </v-card>
                </template>
              </v-dialog>
            </v-card-actions>
            <!-- RESIDENCE VERIFICATION -->
            <v-card-subtitle class="text-center">
              <span class="d-block">Upload: Verify your residential address,</span>
              kindly submit supporting documents in either PNG, JPG, or JPEG
              format.
            </v-card-subtitle>
            <div class="custom-upload-area">
              <input type="file" ref="identityFileInput" class="file-input" accept="image/jpeg,image/jpg,image/png"
                @change="handleIdentityFile" />

              <div class="content">
                <v-row style="position: absolute; bottom: 40px; right: 50%" v-if="identityUploading">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>

                <v-icon large class="mb-3" color="#708AA7">mdi mdi-tray-arrow-up</v-icon>
                <p class="mb-0">Drop File Here or <strong>Browse</strong></p>
                <span class="text-sm">File size max 4MB</span>
              </div>
            </div>
          </v-card>

          <v-card v-else class="verification-card pb-0" style="height: 100%" flat tile
            :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'">
            <v-card-actions class="justify-space-between px-0">
              <v-card-title class="pl-1">
                <v-icon class="pr-5" color="#708AA7">mdi mdi-home-lightning-bolt-outline</v-icon>Residence Verification
              </v-card-title>
              <v-dialog transition="scale-transition" origin="center center" max-width="654"
                content-class="deposit-withdraw-popup">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile text elevation="0" class="text-capitalize link text-decoration-underline" color="#5f7692"
                    v-bind="attrs" v-on="on">Detail</v-btn>
                </template>
                <template v-slot:default="dialog">
                  <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">

                    <v-card-title class="ps-0 pt-0 pb-5 rounded-0">Residence Verification</v-card-title>
                    <v-card-text>
                      <p>
                        Please submit color, high-resolution scans or pictures
                        of a document with your complete name and address on it
                        as proof of residency; the details must match those in
                        your profile. The material must be released no later
                        than three months before the deadline for submission.
                      </p>
                    </v-card-text>
                    <v-card-title class="ps-0 pt-0 pb-5 rounded-0">Upload Requirements for Documents</v-card-title>
                    <v-card-text>
                      <p>
                        To ensure compliance with AML (Anti-Money Laundering)
                        regulations, Forex CRM mandates that all of its clients
                        undergo a verification process. Clients that have
                        undergone verification are free to use any available
                        means to withdraw money and deposit it into their
                        trading accounts.
                      </p>
                    </v-card-text>
                    <v-card-text>
                      <p>
                        Please upload a colour photo or a scanned copy of one of
                        the following papers to help us verify your identity and
                        address:
                      </p>
                    </v-card-text>
                    <ol class="mb-5">
                      <li>Passport local (ID, IC)</li>
                      <li>Foreign Passport</li>
                      <li>License to Drive</li>
                      <li>Receipt of Utility Bill</li>
                      <li>A Bank Statement</li>
                    </ol>
                    <v-card-text>
                      <p>
                        Each document must be a high-resolution colour scan or
                        photo with a validity period of at least six months that
                        clearly shows your full name, photo, signature, date of
                        birth, and expiration date. Make sure the image captures
                        the document's four edges.
                      </p>
                    </v-card-text>
                  </v-card>
                </template>
              </v-dialog>
            </v-card-actions>
            <v-card-text class="content">
              <v-icon color="greenMain">mdi mdi-home-sound-in-outline</v-icon>
              <h3>Residence Verified</h3>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- uploaded images status section -->
      <v-row dense>
        <v-col lg="6" md="6" sm="12" cols="12" v-for="(type, typeIndex) in ['residence','identity']" :key="type">
          <v-card v-for="(data, index) in getDocuments(type)" :key="index" flat tile
            :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'" class="listing-upload">
            <v-row no-gutters justify="space-between" align="center">
              <v-col cols="4">
                <v-card-title>Date & Time</v-card-title>
                <v-card-subtitle class="text-start">{{ formatMySQLDate(data?.created_at) }}</v-card-subtitle>
              </v-col>

              <v-col cols="3">
                <v-card-title class="comment-title">Comment</v-card-title>
                <v-dialog transition="scale-transition" origin="center center" max-width="554"
                  content-class="deposit-withdraw-popup" v-model="dialogs[`comment_${type}_${data?.id}`]">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text elevation="0" class="text-capitalize pa-0 see-details-btn" v-bind="attrs" v-on="on">See
                      Details</v-btn>
                  </template>
                  <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                    <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'"
                      @click="closeDialog(`comment_${type}_${data?.id}`)"
                      style="position: absolute; top: 1rem; right: 1rem; z-index: 1;">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-card-title class="rounded-0">Comment</v-card-title>
                    <ol style="list-style-type: none">
                      <li>{{ data?.comment }}</li>
                    </ol>
                  </v-card>
                </v-dialog>
              </v-col>

              <v-col cols="2">
                <v-card-title class="d-block">Status</v-card-title>
                <v-card-subtitle
                  :style="{ color: data?.status === 2 ? '#D19909' : data?.status === 1 ? '#039de9' : '#ff567f' }">
                  {{ data?.status === 2 ? "Pending" : data?.status === 1 ? "Approved" : "Rejected" }}
                </v-card-subtitle>
              </v-col>

              <v-col cols="2">
                <v-dialog max-width="554" v-model="dialogs[`image_${type}_${data?.id}`]">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn elevation="0" v-bind="attrs" v-on="on" class="icon-btn"
                      @click="openImagePreview(type, data)">
                      <v-img class="white--text align-end" :src="data?.document_url" width="40"></v-img>
                    </v-btn>
                  </template>
                  <v-card class="rounded-0 bg-transparent" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                    <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'"
                      @click="closeDialog(`image_${type}_${data?.id}`)"
                      style="position: absolute; top: 1rem; right: 1rem; z-index: 1;">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-img class="white--text align-end" :src="previewImages[type]"></v-img>
                  </v-card>
                </v-dialog>
              </v-col>

              <v-col cols="1">
                <v-btn v-if="data?.status === 2" small :loading="closeLoading[data?.id]"
                  :disabled="closeLoading[data?.id]" class="closeBtn" @click.prevent="deleteImage(type, data)">
                  <v-icon :color="$vuetify.theme.dark ? '#ff567f' : '#f38da7'">mdi-close</v-icon>
                </v-btn>
                <v-icon v-else class="align-center" color="#708AA7">mdi-dots-horizontal</v-icon>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

    </v-container>
  </div>
</template>

<script>
import toast from "@/services/Notification";
import {
  CITIES__ACTIONS,
  COUNTRIES__ACTIONS,
  PROFILE__ACTIONS,
  STATES__ACTIONS,
} from "@/store/action-types";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapActions, mapState } from "vuex";

export default {
  name: "profileAndVerification",
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      activePicker: "",
      clientInfo: {
        country: "",
        city: "",
        state: "",
        postal_code: "",
        address: "",
        dob: "",
        mobile: "",
      },
      // ✅ 2FA states
      twoFaDialog: false,
      twoFaLoading: false,
      twoFaConfirmLoading: false,
      twoFaOtp: "",
      twoFaMode: "setup", // 'setup' | 'activate' | 'disable'

      closeLoading: {},
      date: "",
      dialogs: {},
      dragging: false,
      dropzoneOptions: {
        acceptedFiles: "image/jpeg,image/png",
        url: "https://httpbin.org/post",
        thumbnailWidth: 100,
        maxFilesize: 3 * 1024 * 1024,
        headers: { "My-Awesome-Header": "header value" },
        maxFiles: 1,
        addRemoveLinks: true,
      },
      editDialogOpen: false,
      identityUploading: false,
      isLoading: false,
      menu: false,
      origin: "",
      pdfImage: window.location.origin + "/static/images/pdf.png",
      previewImages: {
        identity: "",
        residence: ""
      },
      residentUploading: false,
    };
  },
  computed: {
    ...mapState("cities", ["cities"]),
    ...mapState("countries", ["countries"]),
    ...mapState("profile", ["client", "documentInfo" , "twoFaSetup"]),
    ...mapState("states", ["states"]),

    // ✅ show/hide 2FA block (broker flag)
    show2faBlock() {
      if (!this.client) return false;
      if (this.client.client_2fa_enabled === undefined) return true;
      return Number(this.client.client_2fa_enabled) === 1;
    },

    // ✅ enabled status (user flag)
    is2faEnabled() {
      const v =
        this.client?.two_fa_enabled ?? this.client?.two_step_verification ?? 0;
      return Number(v) === 1;
    },

    // ✅ registered secret exists (NO need to expose real secret)
    has2faSecret() {
      // backend recommended flag
      if (this.client?.two_fa_secret_exists !== undefined) {
        return Number(this.client.two_fa_secret_exists) === 1;
      }
      // fallback
      const s = this.client?.two_fa_secret;
      return !!(s && String(s).trim().length > 0);
    },

    twoFaDialogTitle() {
      if (this.twoFaMode === "disable") return "Disable Two-Factor Authentication";
      if (this.twoFaMode === "activate") return "Enable Two-Factor Authentication";
      return "Enable Two-Factor Authentication";
    },

    twoFaConfirmBtnText() {
      if (this.twoFaMode === "disable") return "Confirm & Disable";
      return "Confirm & Enable";
    },

    profileImageUrl() {
      const url = this.client?.profile_pic_url;
      if (!url) return "/user.png";
      const img = this.client?.profile_pic_url.split('.koingate.net/')[1];
      return "https://bucket.koingate.net/" + img;
    }
  },
  methods: {
    ...mapActions("profile", [
      PROFILE__ACTIONS.GETPROFILE,
      PROFILE__ACTIONS.FETCHDOCUMENTS,
      PROFILE__ACTIONS.IDENTITYVERIFICATION,
      PROFILE__ACTIONS.RESIDENCEVERIFICATION,
      PROFILE__ACTIONS.CHANGE_PROFILE_URL,
      PROFILE__ACTIONS.UPDATEPROFILEINFO,
      PROFILE__ACTIONS.DELETEDOCUMENT,

        // ✅ 2FA actions
      PROFILE__ACTIONS.TWOFA_START,     // returns qr + setup_token
      PROFILE__ACTIONS.TWOFA_ENABLE,    // setup enable (otp + setup_token)
      PROFILE__ACTIONS.TWOFA_ACTIVATE,  // enable using saved secret (otp only)
      PROFILE__ACTIONS.TWOFA_DISABLE,   // disable using saved secret (otp only)
    ]),
    ...mapActions("countries", [COUNTRIES__ACTIONS.COUNTRIES]),
    ...mapActions("cities", [CITIES__ACTIONS.CITIES]),
    ...mapActions("states", [STATES__ACTIONS.STATES]),
    ...mapActions("profile", {
      BECOMEANIB: PROFILE__ACTIONS.BECOMEANIB,
    }),

    SaveMenu(date) {
      this.menu = false;
    },

    // SaveMenu(date) {
    //   this.menu = false;
    // },

    formatMySQLDate(mysqlDate) {


      // Ensure the input is in the correct format
      if (!mysqlDate) return "Invalid date";

      // Replace the "T" with a space to work with the current logic
      const isoFormattedDate = mysqlDate.replace("T", " ").split(".")[0]; // Removes milliseconds
      const [datePart, timePart] = isoFormattedDate.split(" ");
      const [year, month, day] = datePart.split("-");
      const [hour, minute] = timePart.split(":");

      // Convert 24-hour time to 12-hour time
      const hour12 = hour % 12 || 12;
      const amPm = hour >= 12 ? "pm" : "am";

      // Return the formatted date and time
      return `${day}.${month}.${year} - ${hour12}:${minute} ${amPm}`;
    },

    async onCountryChange(value) {
      await this[STATES__ACTIONS.STATES](value);
      this.clientInfo.country = value;
    },

    async onStateChange(value) {
      await this[CITIES__ACTIONS.CITIES](value);
      this.clientInfo.state = value;
    },

    onCityChange(value) {
      this.clientInfo.city = value;
    },


    async updateProfile() {
      try {
        this.isLoading = true;
        const requestData = {
          country_id: this.clientInfo.country || this.client?.country_id,
          city_id: this.clientInfo.city || this.client?.city_id,
          state_id: this.clientInfo.state || this.client?.state_id,
          postal_code: this.clientInfo.postal_code || this.client?.postal_code,
          address: this.clientInfo.address || this.client?.address,
          dob: this.formatDate(this.date) || this.formatDate(this.client?.dob),
          mobile: this.clientInfo.mobile || this.client?.mobile,
        };
        await this[PROFILE__ACTIONS.UPDATEPROFILEINFO](requestData);

      } catch (error) {
        console.log(error)
      } finally {
        this.clientInfo.country = "";
        this.clientInfo.city = "";
        this.clientInfo.state = "";
        this.clientInfo.postal_code = "";
        this.clientInfo.address = "";
        this.clientInfo.mobile = "";
        this.date = "";
        setTimeout(() => {
          this.isLoading = false;
          this.editDialogOpen = false
        }, 500);
      }

    },

    formatDate(value) {
      if (
        Object.prototype.toString.call(value) === "[object Date]" &&
        !isNaN(value.getTime())
      ) {
        return value.toISOString().split("T")[0];
      }
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        return date.toISOString().split("T")[0];
      } else {
        return null;
      }
    },

    openFileInput() {
      this.$el.querySelector('input[type="file"]').click();
    },

    uploadImage(file) {
      const formData = new FormData();
      formData.append("profile_url", file);
      this[PROFILE__ACTIONS.CHANGE_PROFILE_URL](formData);
    },

    handleImageChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.uploadImage(file);
      }
    },

    getDocuments(type) {
      return type === 'identity'
        ? this.documentInfo?.identityVerificationDocuments
        : this.documentInfo?.residenceVerificationDocuments;
    },

    openImagePreview(type, data) {
      this.previewImages[type] = data?.document_url;
      this.$set(this.dialogs, `image_${type}_${data?.id}`, true);
    },

    closeDialog(dialogKey) {
      this.$set(this.dialogs, dialogKey, false);
      if (dialogKey.includes('image_')) {
        const type = dialogKey.includes('identity') ? 'identity' : 'residence';
        this.previewImages[type] = "";
      }
    },

    initializeFormData() {
      this.clientInfo = {
        country: this.client?.country_id || "",
        city: this.client?.city_id || "",
        state: this.client?.state_id || "",
        postal_code: this.client?.postal_code || "",
        address: this.client?.address || "",
        mobile: this.client?.mobile || "",
      };
      this.date = this.formatDate(this.client?.dob) || "";

      if (this.client?.country_id) {
        this[STATES__ACTIONS.STATES](this.client.country_id);
      }
      if (this.client?.state_id) {
        this[CITIES__ACTIONS.CITIES](this.client.state_id);
      }
    },

    handleIdentityFile(event) {
      const file = event.target.files[0];
      this.identityVerificationFileUpload(file);
    },

    handleResidenceFile(event) {
      const file = event.target.files[0];
      this.residenceVerificationFileUpload(file);
    },

    removeIdentityFile() {
      if (this.$refs.identityFileInput) {
        this.$refs.identityFileInput.value = "";
      }
    },

    removeResidenceFile() {
      if (this.$refs.residenceFileInput) {
        this.$refs.residenceFileInput.value = "";
      }
    },

    async identityVerificationFileUpload(file) {
      this.identityUploading = true;
      try {
        if (!file) {
          toast.error("Please select a file to upload!");
          this.removeIdentityFile();
          return;
        }

        if (file.size > 4 * 1024 * 1024) {
          toast.error("File size should be less than 4MB");
          this.removeIdentityFile();
          return;
        }

        const allowedFileTypes = ["image/jpeg", "image/jpg", "image/png"];
        if (!allowedFileTypes.includes(file.type)) {
          toast.error("Invalid file format. Upload JPG, JPEG, or PNG only.");
          this.removeIdentityFile();
          return;
        }

        const formData = new FormData();
        formData.append("identityVerification", file);

        await this[PROFILE__ACTIONS.IDENTITYVERIFICATION](formData);

      } catch (error) {
        console.error("Upload error:", error);
        toast.error("Something went wrong during the upload.");
      } finally {
        this.identityUploading = false;
        this.removeIdentityFile();
      }
    },

    async residenceVerificationFileUpload(file) {
      this.residentUploading = true;

      try {
        // No file
        if (!file) {
          toast.error("Please select a file to upload!");
          this.removeResidenceFile();
          return;
        }

        // Max size 4MB
        if (file.size > 4 * 1024 * 1024) {
          toast.error("File size should be less than 4MB");
          this.removeResidenceFile();
          return;
        }

        // Allowed formats
        const allowedFileTypes = ["image/jpeg", "image/jpg", "image/png"];
        if (!allowedFileTypes.includes(file.type)) {
          toast.error("Invalid file format. Upload JPG, JPEG, or PNG only.");
          this.removeResidenceFile();
          return;
        }

        // Prepare formData
        const formData = new FormData();
        formData.append("residenceVerification", file);

        // Send to backend
        await this[PROFILE__ACTIONS.RESIDENCEVERIFICATION](formData);

      } catch (error) {
        console.error("Upload error:", error);
        toast.error("Something went wrong during the upload.");
      } finally {
        this.residentUploading = false;

        // Clear file input
        this.removeResidenceFile();
      }
    },

    async deleteImage(type, data) {
      const docId = data?.id;
      if (!docId) return;
      this.$set(this.closeLoading, docId, true);
      try {
        await this[PROFILE__ACTIONS.DELETEDOCUMENT](docId);
        await this[PROFILE__ACTIONS.FETCHDOCUMENTS]();
      } catch (error) {
        console.error("Upload error:", error);
        toast.error("Something went wrong during delete Image.");
      } finally {
        setTimeout(() => {
          this.$delete(this.closeLoading, docId);
        }, 500);
      }
    },

     // ✅ Toggle dialog open (Enable/Disable)
    async open2faToggleDialog() {
      this.twoFaOtp = "";
      this.twoFaDialog = true;

      // If currently enabled -> disable mode
      if (this.is2faEnabled) {
        this.twoFaMode = "disable";
        this.twoFaLoading = false;
        return;
      }

      // If disabled -> either setup (no secret) or activate (secret exists)
      if (this.has2faSecret) {
        this.twoFaMode = "activate";
        this.twoFaLoading = false;
        return;
      }

      // Not registered -> setup mode: fetch QR + setup_token
      this.twoFaMode = "setup";
      this.twoFaLoading = true;
      try {
        await this[PROFILE__ACTIONS.TWOFA_START]();
      } catch (e) {
        toast.error("Failed to start 2FA setup");
        this.twoFaDialog = false;
      } finally {
        this.twoFaLoading = false;
      }
    },

    close2faDialog() {
      this.twoFaDialog = false;
      this.twoFaOtp = "";
      this.twoFaConfirmLoading = false;
      this.twoFaLoading = false;
      this.$store.commit("profile/CLEAR_TWOFA_SETUP");
    },

    // ✅ Confirm enable/activate/disable based on mode
    async confirmTwoFaToggle() {
      if ((this.twoFaOtp || "").length !== 6) return;

      this.twoFaConfirmLoading = true;
      try {
        // setup: otp + setup_token
        if (this.twoFaMode === "setup") {
          if (!this.twoFaSetup?.setup_token) {
            toast.error("2FA setup token missing. Please try again.");
            return;
          }

          const ok = await this[PROFILE__ACTIONS.TWOFA_ENABLE]({
            otp: this.twoFaOtp,
            setup_token: this.twoFaSetup.setup_token,
          });

          if (ok) toast.success("2FA enabled successfully");
        }

        // activate: otp only against saved secret
        if (this.twoFaMode === "activate") {
          const ok = await this[PROFILE__ACTIONS.TWOFA_ACTIVATE]({
            otp: this.twoFaOtp,
          });

          if (ok) toast.success("2FA enabled successfully");
        }

        // disable: otp only against saved secret
        if (this.twoFaMode === "disable") {
          const ok = await this[PROFILE__ACTIONS.TWOFA_DISABLE]({
            otp: this.twoFaOtp,
          });

          if (ok) toast.success("2FA disabled successfully");
        }

        this.close2faDialog();
        await this[PROFILE__ACTIONS.GETPROFILE](); // refresh flags
      } catch (e) {
        toast.error("Invalid OTP or failed action");
      } finally {
        this.twoFaConfirmLoading = false;
      }
    },

    
  },
  async mounted() {
    try {
      await this[COUNTRIES__ACTIONS.COUNTRIES]();
      await this[PROFILE__ACTIONS.GETPROFILE]();
      await this[PROFILE__ACTIONS.FETCHDOCUMENTS]();
      await this[PROFILE__ACTIONS.GETPROFILE]();
      console.log("PROFILE =>", this.client);
      console.log("client_2fa_enabled =>", this.client?.client_2fa_enabled);
      console.log(this.client)
    } catch (error) {
      console.log(error);
    }
  },
};
</script>

<style scoped>
.closeBtn {
  background: none !important;
  box-shadow: none;
}

.closeBtn:hover {
  box-shadow: none;
}

.align-center {
  text-align: center;
}

.content {
  padding: 0 !important;
  height: calc(100% - 120px);
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}


.custom-upload-area {
  border: 1px dashed #7644f53b;
  border-radius: 6px;
  padding: 20px;
  position: relative;
  cursor: pointer;
  min-height: 180px;
  text-align: center;
}

.custom-upload-area:hover {
  background: rgba(112, 138, 167, 0.08);
}

.file-input {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  cursor: pointer;
}

.text-sm {
  font-weight: normal;
  font-size: 13px;
}

.twofa-dialog .twofa-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.twofa-header {
  position: relative;
}

.twofa-title {
  font-weight: 700;
  font-size: 18px;
  line-height: 1.2;
}

.twofa-subtitle {
  font-size: 13px;
  opacity: 0.8;
  margin-top: 4px;
}

.twofa-divider {
  opacity: 0.15;
}

.twofa-steps .step-title {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 8px;
}

.step-list {
  margin: 0;
  padding-left: 18px;
  font-size: 13px;
  line-height: 1.6;
  opacity: 0.9;
}

.twofa-qr-wrap,
.twofa-otp-wrap {
  border-radius: 12px;
  padding: 14px;
  border: 1px solid rgba(126, 166, 214, 0.15);
}

.qr-title,
.otp-title {
  font-weight: 700;
  font-size: 14px;
}

.qr-hint,
.otp-note {
  font-size: 12px;
  opacity: 0.75;
}

.twofa-qr {
  border-radius: 10px;
  padding: 8px;
  background: rgba(255, 255, 255, 0.06);
}

.twofa-otp-input {
  border-radius: 10px;
}

.twofa-action {
  width: 100%;
  height: 44px;
  font-weight: 700;
  letter-spacing: 0.3px;
}

.twofa-cancel {
  text-transform: none !important;
  opacity: 0.85;
}
</style>
